import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import { TimePicker } from 'antd';
import { TimePickerProps } from 'antd/lib';
import dayjs from 'dayjs';
import * as React from 'react';

export interface IEmrTimeProps extends IEmrInputProps {
  timePickerProps?: TimePickerProps & React.RefAttributes<any>;
}

const EmrTime: React.FC<IEmrTimeProps> = ({
  name,
  field,
  disabled,
  timePickerProps = {},
  labelProps = {},
  ...props
}) => {
  return (
    <EmrFormItem
      name={name}
      field={field}
      getValueProps={(value) => {
        if (value) return { value: value ? dayjs(value) : null };
        return {};
      }}
      getValueFromEvent={(val) => {
        return val ? dayjs(val).toISOString() : val;
      }}
      initialValue={disabled ? undefined : field?.default ? dayjs() : undefined}
      {...labelProps}
    >
      <TimePicker
        disabled={disabled}
        popupClassName="base-popup-time-picker"
        className={'base-time-picker w-full '}
        format={field?.extra.format}
        {...timePickerProps}
      />
    </EmrFormItem>
  );
};
export default EmrTime;
